import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { EvaCheckboxModule } from '../eva-checkbox/eva-checkbox.module';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { OffersFiltersComponent } from './offers-filters.component';
import { OffersFiltersContentComponent, OffersFiltersModalContentComponent } from './offers-filters-content.component';
import { EvaTagModule } from '../eva-tag/eva-tag.module';
import { SliderRangeModule } from '../slider-range/slider-range.module';
import { EmptyStateModule } from '../empty-state/empty-state.module';
import { TranslateModule } from '@ngx-translate/core';
import { EvaDropdownModule } from '../eva-dropdown/eva-dropdown.module';
import { TooltipModule } from '@shopping-angular-components/tooltip';
import { FormsModule } from '@angular/forms';
import { DiscreteFilterComponent } from './discrete-filter.component';
import { IconsModule } from "../icons/icons.module";
import { SortingSelectComponent } from "../sorting-select/sorting-select.component";

@NgModule({
  declarations: [
    OffersFiltersComponent,
    OffersFiltersContentComponent,
    OffersFiltersModalContentComponent,
    DiscreteFilterComponent
  ],
  imports: [
    CommonModule,
    EvaButtonModule,
    TooltipModule,
    EvaCheckboxModule,
    EvaTagModule,
    SliderRangeModule,
    EmptyStateModule,
    EvaButtonModule,
    TranslateModule,
    EvaDropdownModule,
    FormsModule,
    IconsModule,
    SortingSelectComponent
  ],
  exports: [
    OffersFiltersComponent,
    OffersFiltersContentComponent
  ],
  providers: [
    LandingModelService
  ]
})
export class OffersFiltersModule { }
